import { AngularFireAuth } from "angularfire2/auth";
import { Component } from "@angular/core";
import {
  NavController,
  AlertController,
  ViewController,
  Platform,
} from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { LoginPage } from "../login/login";
import { LoginEmailPage } from "../login-email/login-email";
import { WalletPage } from "../wallet/wallet";

import { Settings, User, Wallet } from "../../app/app.models";
import { SettingsFetchAction, WalletFetchAction } from "../../app/app.actions";
//import { SettingschangepassPage } from '../settingschangepass/settingschangepass';
import { WalletService } from "../../services/wallet.service";
import { TranslateService } from "@ngx-translate/core";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-settings",
  templateUrl: "settings.html",
})
export class SettingsPage {
  public settings$: Settings;
  // public settingschangepassPage = SettingschangepassPage;
  idioms: any[] = [];
  user$: User;
  wallet$: Wallet;

  constructor(
    public afAuth: AngularFireAuth,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public store: Store<AppState>,
    private walletService: WalletService,
    private translateService: TranslateService,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private platform: Platform
  ) {
    store.select("user").subscribe((user: User) => {
      if (user) {
        /*store.dispatch(new SettingsFetchAction(user.uid));
        this.user$ = user;*/
      }
    });

    /** store.select('settings').subscribe((settings: Settings) => {
      this.settings$ = settings;
    }); */

    this.store.select("wallet").subscribe((wallet: Wallet) => {
      this.wallet$ = wallet;
    });

    this.idioms = [
      {
        value: "es",
        label: "Español",
      },
      {
        value: "en",
        label: "English",
      },
    ];
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad SettingsPage");
  }

  ionViewWillEnter() {}

  logout() {
    var logout_alert_title = this.translateService.instant(
      "settings.logout_alert_title"
    );
    var logout_alert_message = this.translateService.instant(
      "settings.logout_alert_message"
    );
    var save_seed = this.translateService.instant("settings.save_seed");
    var logout_sign_off = this.translateService.instant(
      "settings.logout_sign_off"
    );

    let alert = this.alertCtrl.create({
      title: logout_alert_title,
      //message: logout_alert_message,
      //cssClass: "wallet-seeds-alert",
      buttons: [
        {
          text: save_seed,
          handler: () => {
            console.log("Cancel clicked");
            this.navCtrl.push(WalletPage);
          },
        },
        {
          text: logout_sign_off,
          handler: () => {
            console.log("Buy clicked");
            //this.walletService.generateNewSeeds();
            //this.walletService.setShowAlert(true);
            this.configService.setShowSlides("yes");
            this.configService.setShowSeedsMessage("yes");
            //this.store.dispatch(new WalletFetchAction(this.user$));
            this.afAuth.auth.signOut();
            //this.platform.exitApp();
            this.navCtrl.setRoot(LoginEmailPage);
          },
        },
      ],
    });
    alert.present();
  }

  choose(lang) {
    this.configService.setIdiom(lang);
    this.translateService.use(lang);
  }

  openTelegram() {
    console.log("Telegram");
    const url = "https://t.me/Watafan";
    //Abre la URL en el navegador del sistema
    window.open(url, "_system");
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts